@for (key of keys; track key) {
    <fui-key id="{{key}}-key" (key)="add(key)" [title]="key"></fui-key>
}
<fui-key id="backspace-key" (key)="backspace()">
    <fui-icon [height]="15" [icon]="'backspace'" [width]="30"></fui-icon>
</fui-key>
